import { createAction } from '@reduxjs/toolkit';
import { ICommonLoadActionType, ICommonSaveActionType, ICommonSavePayload } from '../Common.actions';
import { WatchlistStudent } from '../../types/models/WatchlistStudentModel';

export interface IWatchlistActionTypes extends ICommonSaveActionType, ICommonLoadActionType {
  LOAD_BY_COMPANY: string;
  LOAD_BY_STUDENT: string;
  DELETE: string;
  DELETED: string;
}

export const WATCHLIST: IWatchlistActionTypes = {
  LOAD: 'watchlist/load',
  LOAD_BY_COMPANY: 'watchlist/loadByCompany',
  LOAD_BY_STUDENT: 'watchlist/loadByStudent',
  LOADED: 'watchlist/loadSuccess',
  LOAD_ERROR: 'watchlist/loadError',
  ERROR: 'watchlist/error',
  SAVE: 'watchlist/save',
  SAVED: 'watchlist/saveSuccess',
  SAVE_ERROR: 'watchlist/saveError',
  DELETE: 'watchlist/delete',
  DELETED: 'watchlist/deleteSuccess',
};

// Action Creators
export const watchlistLoadByCompany = createAction<string>(WATCHLIST.LOAD_BY_COMPANY);
export const watchlistLoadByStudent = createAction<string[]>(WATCHLIST.LOAD_BY_STUDENT);
export const watchlistLoadSuccess = createAction<WatchlistStudent[]>(WATCHLIST.LOADED);
export const watchlistLoadError = createAction<string>(WATCHLIST.LOAD_ERROR);

export const watchlistSave = createAction<ICommonSavePayload<any>>(WATCHLIST.SAVE);
export const watchlistSaveSuccess = createAction<WatchlistStudent>(WATCHLIST.SAVED);
export const watchlistSaveError = createAction<string>(WATCHLIST.SAVE_ERROR);

export const watchlistDelete = createAction<string>(WATCHLIST.DELETE);
export const watchlistDeleteSuccess = createAction<string>(WATCHLIST.DELETED);